export default __webpack_public_path__ + "locales/sl/InfoPanel.json?hash=4bb4710deb924fc3661a77c7b287c961";